
import axios from '../utils/axios'

// 管理员进入组织管理页面获取的统计数据
export function getReport() {
    return axios.get('/api/admin/index/report.do')
}
// 根据表单查询大队辅导员数据
export function getReportCounselor(params) {
    return axios.get('/api/report/school/counselor.do', {params})
}

// 根据少工委数据
export function getReportsgw(params) {
    return axios.get('/api/report/sgw/data.do', {params})
}

// 查询需要统计的表单列表
export function getReportform() {
    return axios.get('/api/report/form/list.do')
}

// 查询需要统计的表单列表
export function getWinterProject(params) {
    return axios.get('api/report/winter/project.do', {params})
}